import { users_api_search_users_url } from 'mk/urls/functions';
import {
    usersDirectorySearchAPI,
    UsersDirectorySearchTriggerAction,
    USERS_DIRECTORY_SEARCH_TRIGGER,
} from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.actions';
import { USERS_DIRECTORY_FORM_NAME } from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.constants';
import { UserStatsEntity, UserStatsSchema } from 'mk2/apps/users/schemas';
import { normalizeError, XHRAction, XHRFormError } from 'mk2/helpers/api';
import { handleXHRFormErrorSaga } from 'mk2/helpers/form';
import { removeEmpty } from 'mk2/helpers/urls';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { stopSubmit } from 'redux-form';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('UsersDirectory.sagas');

interface LoadApiResponse {
    body: {
        usersStats: UserStatsEntity[];
        hasMore: boolean;
    };
}

function* searchUsers({ searchFd, xhr }: UsersDirectorySearchTriggerAction & XHRAction) {
    yield put(usersDirectorySearchAPI.request(searchFd));

    try {
        const response: LoadApiResponse = yield call(() =>
            xhr.get(users_api_search_users_url(removeEmpty({
                login: searchFd.login,
                county: searchFd.county,
                place: searchFd.place,
                dueDate: searchFd.dueDate,
                orderBy: searchFd.orderBy,
            }))));

        const normalizedResponse = normalize(
            {
                usersStats: response.body.usersStats,
            },
            {
                usersStats: [UserStatsSchema],
            },
        );

        yield put(usersDirectorySearchAPI.success(searchFd, response.body.hasMore, normalizedResponse));
        yield put(stopSubmit(USERS_DIRECTORY_FORM_NAME));
    } catch (error) {
        yield handleXHRFormErrorSaga(USERS_DIRECTORY_FORM_NAME, error as XHRFormError, logger);
        yield put(usersDirectorySearchAPI.failure(searchFd, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(USERS_DIRECTORY_SEARCH_TRIGGER, searchUsers),
    ]);
}
